import { chowlyApi } from 'config'
import { generatePath } from 'react-router'

import client from '../chowly'
import { MenuMappingChildItem, TypeName } from '../models'

export interface ChildItemUpdateInput {
  childItemId: string
  attributes: {
    item_sort_position?: number
    price?: number
    pickup_price?: number
  }
}

export const updateMenuMappingChildItem = async ({
  childItemId,
  attributes,
}: ChildItemUpdateInput): Promise<MenuMappingChildItem> => {
  const url = generatePath(chowlyApi.menuMappingChildItem, { id: childItemId })

  const payload = {
    data: {
      id: childItemId,
      type: TypeName.MenuMappingChildItem,
      attributes,
    },
  }

  const { data } = await client.patch<MenuMappingChildItem>(url, payload)
  return data
}

export const bulkUpdateChildItems = async (updates: ChildItemUpdateInput[]): Promise<void> => {
  // Update each child item individually since there's no bulk endpoint
  await Promise.all(updates.map(update => updateMenuMappingChildItem(update)))
} 